import React from "react";
import styled from "styled-components";
import { defineMessages, useIntl } from "react-intl";
import { Faq } from "../../../shared/types/faq";
import { FaqItem } from "./TaskTemplateFaqs/FaqItem";

export interface FaqsProps {
  faqsProps: Faq[];
}

const messages = defineMessages({
  title: {
    id: "TaskTemplateServiceFaqs.title",
    defaultMessage: "Frequently asked questions",
  },
});

export function TaskTemplateFaqs({ faqsProps }: FaqsProps) {
  const intl = useIntl();

  if (faqsProps && faqsProps.length) {
    return (
      <VerticalPadding>
        <FaqSection itemScope itemType="https://schema.org/FAQPage">
          <StyledHeader>{intl.formatMessage(messages.title)}</StyledHeader>

          {faqsProps.map((faq) => (
            <FaqItem
              key={faq.question}
              question={faq.question}
              answer={faq.answer}
            />
          ))}
        </FaqSection>
      </VerticalPadding>
    );
  }

  return null;
}

const VerticalPadding = styled.div`
  padding-top: ${(props) => props.theme.spacing.lg};
  padding-bottom: ${(props) => props.theme.spacing.lg};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
`;

const FaqSection = styled.div`
  padding-top: ${(props) => props.theme.spacing.xxl};
  padding-right: ${(props) => props.theme.spacing.xxl};
  padding-left: ${(props) => props.theme.spacing.xxl};
  max-width: 500px;
`;

const StyledHeader = styled.h2`
  text-align: center;
  font-size: 2.2em;
  margin: 0 auto 1em;
  font-weight: 300;
  max-width: 26.5rem;
`;
